export default __webpack_public_path__ + "static/media/f_1.42a972d3.jpg";